import { selector, selectorFamily } from "recoil";

import {
  IDropdownItem,
  IDropdownItemStations,
  RydeUiUnitDropdownCacheKey,
} from "../../models";
import { dropdownAtomFamily, dropdownStationListAtom } from "../atoms";

export const dropdownSelectorFamily = selectorFamily<
  IDropdownItem[],
  RydeUiUnitDropdownCacheKey
>({
  key: "dropdownSelectorFamily",
  get:
    (key: RydeUiUnitDropdownCacheKey) =>
    ({ get }) => {
      return get(dropdownAtomFamily(key));
    },
});

export const activeStationsListSelector = selector<IDropdownItemStations[]>({
  key: "activeStationsListSelector",
  get: ({ get }) => {
    return get(dropdownStationListAtom)?.filter(s => s.isActive) ?? [];
  },
});
